import React from "react";
import styled from "styled-components";

const UniqueContainer = styled.section`
    width: 100%;
    padding: 60px 20px;
    background: #eaeff1;
    box-sizing: border-box;
`;

const UniqueTitle = styled.h2`
    text-align: center;
    font-size: 30px;
    margin-bottom: 50px;
    color: #ff5733;
    font-weight: bold;
`;

const UniqueGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
`;

const UniqueCard = styled.div`
    background-color: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 300px;
    flex: 1;
    min-width: 240px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }
`;

const UniqueImage = styled.img`
    width: 100%;
    height: 180px;
    object-fit: cover;
`;

const UniqueContent = styled.div`
    padding: 15px;
`;

const UniqueCardTitle = styled.h3`
    font-size: 20px;
    margin-bottom: 10px;
    color: #ff5733;
`;

const UniqueCardDescription = styled.p`
    font-size: 14px;
    color: #37435d;
    line-height: 1.3;
`;

const portfolioData = [
  {
    image: "port1.jpg",
    title: "Éducation Financière",
    description:
      "Nous développons des solutions innovantes pour optimiser votre connaissance en matière de capital et de stabilité financière."
  },
  {
    image: "port2.jpg",
    title: "Plateforme d'Apprentissage en Ligne",
    description:
      "Nous créons des plateformes centrées sur l'éducation économique, alliant technologie et stratégie pour un développement personnel."
  },
  {
    image: "port3.jpg",
    title: "Communauté d'Investissement",
    description:
      "Nous mettons en œuvre des solutions personnalisées pour favoriser la sécurité financière et la croissance à long terme."
  },
  {
    image: "port4.jpg",
    title: "Stratégies d'Investissement Durable",
    description:
      "Nous concevons et exécutons des stratégies innovantes qui favorisent la stabilité et les nouvelles opportunités dans l'économie moderne."
  }
];

const UniqueComponent = () => {
  return (
    <UniqueContainer>
      <UniqueTitle>France Investment - Nos Propositions Exclusives</UniqueTitle>
      <UniqueGrid>
        {portfolioData.map((item, index) => (
          <UniqueCard key={index}>
            <UniqueImage src={item.image} alt={item.title} />
            <UniqueContent>
              <UniqueCardTitle>{item.title}</UniqueCardTitle>
              <UniqueCardDescription>{item.description}</UniqueCardDescription>
            </UniqueContent>
          </UniqueCard>
        ))}
      </UniqueGrid>
    </UniqueContainer>
  );
};

export default UniqueComponent;